/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';

export default declareLinkedEntity({
    entity: "screenBoxToAdd",
    graphQL: "ScreenBoxToAdd",
    name: "Box To Add",
    storageType: 'central',
    userEditable: false,
    fields: (types) => { return {
        id: {
            name: "Box to Add ID",
            type: "string",
            id: true,
            defaultValue: () => {
                return uuidv4();
            },
            required: true,
            primaryKey: true,
        },
        type: {
            name: "Type",
            type: "enum",
            values: {
                "entityViewDef": {
                    name: "Entity View Definition"
                },
                "relationDef": {
                    name: "Relation Definition"
                }
            }
        },
        name: {
            name: "Name",
            type: "string",
            translatable: true,
            defaultValue: "",
        },
        handler: {
            name: "Handler",
            type: "string",
            defaultValue: "",
        },
        dataSource: {
            name: "Data Source",
            type: "relation",
            to: () => types['dataSources'],
            hiddenCreate: true,
            relativeTo: ['screen'],
        },
        screen: {
            name: "Screen",
            type: "relation",
            to: () => types['screens'],
            defaultValue: (screen) => {
                return screen['id'];
            },
            required: true,
            parent: true,
            compositeKey: true,
            hiddenCreate: true,
        },
        entityDef: {
            name: "Entity Definition",
            type: "relation",
            to: () => types['entityDefs'],
        },
        connectedChannel: {
            name: "Connected Application",
            description: "If this view needs some application, this is the link",
            type: "relation",
            to: () => types['channels'],
        },
        connectedChannelDef: {
            name: "Connected Application Def",
            description: "If this view needs some application, this is the link to channelDef for later reconstruction",
            type: "relation",
            to: () => types['channelDefs'],
        },
        dependsOnChannelDef: {
            name: "Dependes on ChannelDef",
            to: () => types['channelDefs'],
            type: "relation",
            filterable: true,
        },
        hideInDefaultQuery: {
            name: "Hide in default query",
            description: "When looking on entry as default query, hide this view.",
            type: "boolean",
        },
        entityViewDef: {
            name: "Entity View Definition",
            type: "relation",
            to: () => types['entityViewDefs'],
        },
        backendOptions: {
            name: "Backend Options",
            type: "object",
            defaultValue: {},
        },
        filter: {
            name: "Filter",
            type: "object",
            defaultValue: {},
            description: "Filter object for data query",
            isPublic: true,
        },
        order: {
            name: "Order",
            type: "object",
            defaultValue: [],
            description: "Order of the data in the query",
            isPublic: true,
        },
        channelAddon: {
            name: "Application Addon",
            type: "relation",
            to: () => types['channelAddons'],
            relativeTo: ['channelAddonChannel'],
        },
        channelAddonChannel: {
            name: "Application Addon Application",
            type: "relation",
            to: () => types['channels'],
        },
    }; },
    relations: (types) => { return {
    }; }
});
